import {
  GetUserPreferencesV2Command,
  GetUserPreferencesV2CommandInput,
  UpdateUserPreferencesV2Command,
  UpdateUserPreferencesV2CommandInput,
} from '@amzn/gbsa-orbit-typescript-client';
import { apiOrbitClient } from 'src/data/api/apiOrbitClient';

export const userPreferencesService = {
  get: (data: GetUserPreferencesV2CommandInput) => {
    return apiOrbitClient.send(new GetUserPreferencesV2Command(data));
  },

  update: (data: UpdateUserPreferencesV2CommandInput) => {
    return apiOrbitClient.send(new UpdateUserPreferencesV2Command(data));
  },
};
